import React from 'react';
import styled from 'styled-components';

import { formatNumber } from '#/lib/display/formatting';
import { useSelectPendingDepositListExcludingFailed } from '#/reduxState/balances/pendingDepositsUtils';

const PendingBlock = styled.div`
  color: var(--gray4);
  padding-top: 4px;
`;

export default function BalanceStatsPendingFunds() {
  const pendingDepositsList = useSelectPendingDepositListExcludingFailed();
  const pendingDepositsSum = pendingDepositsList
    .map(deposit => Number(deposit.quantity))
    .reduce((a, b) => a + b, 0);

  if (pendingDepositsSum === 0) {
    return null;
  }

  return (
    <PendingBlock>
      {pendingDepositsSum < 0.1
        ? '< 0.1'
        : formatNumber(pendingDepositsSum, { fixedDecimals: 2 })}{' '}
      USDC pending
    </PendingBlock>
  );
}
